import { render, staticRenderFns } from "./CompanyDetailsModal.vue?vue&type=template&id=60c0d358&scoped=true"
import script from "./CompanyDetailsModal.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailsModal.vue?vue&type=style&index=0&id=60c0d358&prod&scoped=true&lang=css"
import style1 from "./CompanyDetailsModal.vue?vue&type=style&index=1&id=60c0d358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0d358",
  null
  
)

export default component.exports